export default {
  "Choose File": "Choisir un fichier",
  "Please paste a URL": "Veuillez coller une adresse URL",
  Loading: "Chargement",
  Analyzing: "Analyse en cours",
  "Try a sample": "Essayer un échantillon",
  "Sorry, error occurs when analyzing the URL.": "Désolé, une erreur se produit lors de l'analyse de l'URL.",
};
